import FirstScreenSection from './FirstScreenSection'
export default FirstScreenSection